// Import Headroom.js
import Headroom from 'headroom.js';

// Grab the site header element
var celHeader = document.getElementById('headerArea');

// Construct an instance of Headroom, passing the element
var headroom  = new Headroom(celHeader);

// Initialize Headroom with options
headroom.init({
    offset : 50,
    tolerance : 10
});